import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { loader } from '@monaco-editor/react';
import App from './App.tsx';
import { initSentry } from './utils/sentry';
import './styles/index.css';

// Initialize Sentry as early as possible
initSentry();

// Configure Monaco Editor to avoid CSP worker issues
loader.config({
  'vs/nls': {
    availableLanguages: {
      '*': 'en'
    }
  }
});

// Configure Monaco Environment to disable workers for CSP compliance
(window as any).MonacoEnvironment = {
  getWorker: function () {
    // Return null to disable web workers and use main thread instead
    return null;
  }
};

// Create error boundary wrapper component
const SentryErrorBoundary = Sentry.ErrorBoundary;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SentryErrorBoundary fallback={<div>An error has occurred</div>}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </SentryErrorBoundary>
  </React.StrictMode>
);
